import { HorizontalContainer } from '@american-autonomy/ag-ui';

import Card from 'components/Card';
import Grid from 'components/Grid';

import useSlider from 'hooks/useSlider';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BleedingCards: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => {
    const { ref } = useSlider();

    return (
        <HorizontalContainer className={`${className} ${styles.bleedingCards}`} testId={testId}>
            <Grid className={styles.outerGrid} ref={ref} testId='outerGrid'>
                <Card />

                <Grid className={styles.innerGrid} ref={ref} testId='innerGrid'>
                    {children}
                </Grid>

                <Card />
            </Grid>
        </HorizontalContainer>
    );
};

export default BleedingCards;
